import { c as _c } from "react/compiler-runtime";
import type { Address } from '@newfront-insurance/address-api';
import { colors, Flexbox, IconTick, Padding, Spacing, Stack, Text, IconWarning } from '@newfront-insurance/core-ui';
import * as React from 'react';
import type { JSX } from 'react';
import type { internationalStreet } from 'smartystreets-javascript-sdk';
import styled from 'styled-components';
import { formatCandidateToAddress } from '../../../utils/format-street-address';
interface Props {
  isActive?: boolean;
  onChange?: (value?: string) => unknown;
  candidate?: internationalStreet.Candidate;
  enteredAddress?: Address;
}
export function SelectableAddress(props) {
  const $ = _c(31);
  let candidate;
  let isActive;
  let onChange;
  let value;
  if ($[0] !== props) {
    const {
      isActive: t0,
      onChange: t1,
      candidate: t2,
      enteredAddress
    } = props;
    onChange = t1;
    candidate = t2;
    isActive = t0 === undefined ? false : t0;
    value = "";
    if (candidate) {
      const {
        formattedAddress
      } = formatCandidateToAddress(candidate);
      value = formattedAddress;
    }
    if (enteredAddress) {
      value = enteredAddress.formattedAddress;
    }
    $[0] = props;
    $[1] = candidate;
    $[2] = isActive;
    $[3] = onChange;
    $[4] = value;
  } else {
    candidate = $[1];
    isActive = $[2];
    onChange = $[3];
    value = $[4];
  }
  let t0;
  if ($[5] !== onChange || $[6] !== value) {
    t0 = e => {
      e.preventDefault();
      if (onChange) {
        onChange(value);
      }
    };
    $[5] = onChange;
    $[6] = value;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const handleChange = t0;
  let t1;
  if ($[8] !== onChange || $[9] !== value) {
    t1 = e_0 => {
      if (e_0.key === " ") {
        if (onChange) {
          onChange(value);
        }
      }
    };
    $[8] = onChange;
    $[9] = value;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const handleKeyDown = t1;
  let t2;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function getVerificationStatus(verificationStatus) {
      if (verificationStatus === "Verified") {
        return;
      }
      return <Flexbox alignItems="center"><IconWarning color={verificationStatus !== "None" ? colors.peach[500] : undefined} size={12} /><Spacing width={4} /><Text size="small" color={colors.steel[400]}>Only some parts of this address were verified</Text></Flexbox>;
    };
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const getVerificationStatus = t2;
  const t3 = isActive ? "active" : "";
  let t4;
  if ($[12] !== isActive) {
    t4 = isActive ? <IconTick /> : false;
    $[12] = isActive;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <Padding right={16}><StyledIconWrapper>{t4}</StyledIconWrapper></Padding>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== value) {
    t6 = value && <Text weight={600}>{value}</Text>;
    $[16] = value;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== candidate) {
    t7 = candidate && getVerificationStatus(candidate.analysis.verificationStatus);
    $[18] = candidate;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <Stack gap={4} direction="vertical">{t6}{t7}</Stack>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t5 || $[24] !== t8) {
    t9 = <Padding y={12}><Flexbox alignItems="center" justifyContent="space-between"><Flexbox alignItems="flex-start">{t5}{t8}</Flexbox></Flexbox></Padding>;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== handleChange || $[27] !== handleKeyDown || $[28] !== t3 || $[29] !== t9) {
    t10 = <StyledRow className={t3} onClick={handleChange} onKeyDown={handleKeyDown} tabIndex={0} role="checkbox">{t9}</StyledRow>;
    $[26] = handleChange;
    $[27] = handleKeyDown;
    $[28] = t3;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
const StyledRow = styled.div`
  cursor: pointer;
`;
const StyledIconWrapper = styled.div`
  align-items: center;
  background-color: #fff;
  border: 1px solid ${colors.steel[200]};
  border-radius: 100%;
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;

  .active & {
    background-color: ${colors.brand[400]};
    border-color: ${colors.brand[400]};
  }
`;